var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4222 2.45602C10.8272 3.06204 10.8272 3.90567 10.8272 5.59293C10.8272 7.28019 10.8272 8.12382 10.4222 8.72984C10.2469 8.99219 10.0217 9.21745 9.75932 9.39275C9.22991 9.74649 8.51917 9.79121 7.22309 9.79686V9.79768L6.559 11.1259C6.33763 11.5686 5.70584 11.5686 5.48447 11.1259L4.82038 9.79768V9.79686C3.52429 9.79121 2.81355 9.74649 2.28415 9.39275C2.02179 9.21745 1.79654 8.99219 1.62124 8.72984C1.21631 8.12382 1.21631 7.28019 1.21631 5.59293C1.21631 3.90567 1.21631 3.06204 1.62124 2.45602C1.79654 2.19367 2.02179 1.96841 2.28415 1.79311C2.89017 1.38818 3.7338 1.38818 5.42106 1.38818H6.62241C8.30967 1.38818 9.1533 1.38818 9.75932 1.79311C10.0217 1.96841 10.2469 2.19367 10.4222 2.45602Z",
    stroke: "#818291",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22119 4.39209L7.82526 4.39209",
    stroke: "#818291",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22119 6.79443H6.02323",
    stroke: "#818291",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.bb408393c95704ec156bb51920f9763f.svg";
export { ForwardRef as ReactComponent };